import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api';

export const fetchEnquiriesList = createAsyncThunk(
  'admin_enquiries/fetchEnquiriesList',
  async ({page, searchTerm=''} , { rejectWithValue }) => {
    try {
      const response = await api.post(
        `${process.env.REACT_APP_API_BASE_URL}/admin/enquiries-list?page=${page}`, {searchTerm:searchTerm}
      );
      return response.data;  // Return videos data
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const enquiriesSlice = createSlice({
  name: 'admin_enquiries',
  initialState: {
    enquiries_list: [],
    currentPage: 1,
    totalPages: 1,
    loading: false,
    errorMessage: ''
  },
  reducers: {
    clearMessage: (state, action) => {
      state.errorMessage = '';
    },
  },
  extraReducers: (builder) => {
    builder      
      // Handle get started videos
      .addCase(fetchEnquiriesList.pending, (state) => {
        state.loading = true;
        state.errorMessage = '';
      })
      .addCase(fetchEnquiriesList.fulfilled, (state, action) => {
        state.enquiries_list = action.payload.data.data;
        state.currentPage = action.payload.data.current_page;
        state.totalPages = action.payload.data.last_page;
        state.loading = false;
      })
      .addCase(fetchEnquiriesList.rejected, (state, action) => {
        state.loading = false;
        state.errorMessage = action.payload ? action.payload.message : action.error.message;
      });    
  },
});

export const { clearMessage } = enquiriesSlice.actions;

export default enquiriesSlice.reducer;
